import { InjectionKey, Ref } from "vue";

export interface OperatingContent {
  operatingExtCalendarId: string,
  displayName: string;
  closedText: string;
  closedToPublicText: string;
  tbdText: string;
  allDayText: string;
  infoHoursHeadline: string;
}

export interface CalendarActivityContent {
  cmsKey: string;
  extCalendarId: string;
  operatingExtCalendarId: string;
  displayName: string;
  shortDescription: string;
  longDescription: string;
  featuredMonthly: boolean;
  featuredDaily: boolean;
  displayDaily: boolean;
  locationName: string;
  thumbnailImageUrl: string;
  duration: string;
  activityUrl: string;
  featuredColor: string;
  featuredTextDark: boolean;
  opsInfoDaily: boolean;
  opsInfoClosedText: string;
}

export interface CalendarActivityContentResponseDto extends OperatingContent {
  // For performance we don't store the entire activity array in ContentLookupClass
  activities: CalendarActivityContent[];
}

export class ContentLookupClass {
  operatingById: { [extCalId: string]: OperatingContent } = {};
  activityById: { [extCalId: string]: CalendarActivityContent } = {};
  operatingExtCalendarIds: string[] = [];
  operatingCalendars: OperatingContent[] = [];
  allActivityExtCalendarIds: string[] = [];

  monthlyFeaturedExtCalendarIds: string[] = [];
  dailyFeaturedExtCalendarIds: string[] = [];
  dailyOperatingInfoExtCalendarIds: string[] = [];
  dailyStandardExtCalendarIds: string[] = [];

  constructor();
  constructor(contentResponse: CalendarActivityContentResponseDto[]);
  constructor(contentResponse?: CalendarActivityContentResponseDto[]) {
    if (contentResponse) {
      contentResponse.forEach(parkHomeContent => {
        const opContent = {
          operatingExtCalendarId: parkHomeContent.operatingExtCalendarId,
          displayName: parkHomeContent.displayName,
          closedText: parkHomeContent.closedText,
          closedToPublicText: parkHomeContent.closedToPublicText,
          tbdText: parkHomeContent.tbdText,
          allDayText: parkHomeContent.allDayText,
          infoHoursHeadline: parkHomeContent.infoHoursHeadline
        } as OperatingContent;

        // Summarize operating calendars
        this.operatingExtCalendarIds.push(parkHomeContent.operatingExtCalendarId);
        this.operatingCalendars.push(opContent);

        // Copy properties manually to exclude parkHomeContent.activities
        this.operatingById[parkHomeContent.operatingExtCalendarId] = opContent;

        // Summarize activity calendars
        parkHomeContent.activities.forEach(activityContent => {
          if (activityContent.extCalendarId) {
            this.allActivityExtCalendarIds.push(activityContent.extCalendarId);

            // Monthly view
            if (activityContent.featuredMonthly) {
              this.monthlyFeaturedExtCalendarIds.push(activityContent.extCalendarId);
            }

            // Daily view
            if (activityContent.displayDaily) {
              if (activityContent.featuredDaily) {
                this.dailyFeaturedExtCalendarIds.push(activityContent.extCalendarId);
              } else {
                this.dailyStandardExtCalendarIds.push(activityContent.extCalendarId);
              }
            }

            // Daily navigator
            if (activityContent.opsInfoDaily) {
              this.dailyOperatingInfoExtCalendarIds.push(activityContent.extCalendarId);
            }

            this.activityById[activityContent.extCalendarId] = activityContent;
          }
        });
      });
    }
  }
}

export const ContentLookup: InjectionKey<Ref<ContentLookupClass>> = Symbol();
